import pick from 'lodash/pick';
import { USER_TYPES } from '../../../auth/constants';
import { defPermissions, restrictivePermissions } from '../../../auth/utils/defaultPermissions';
import { fullName } from '../../../common/helpers/users';

export const getInitialValuesFromUser = (user) => {
  const data = {
    adminPermissions: [],
  };

  if (user.kind === USER_TYPES.shop && user.shops.length) {
    data.shopIds = user.shops.map((shop) => shop.id);
    data.permissions = restrictivePermissions(user.shops[0].permissions);
    data.trackEmployeeTime = user.shops[0].trackEmployeeTime;
    data.permissionPasscodeRequired = user.shops[0].permissionPasscodeRequired;
  }

  if (user.kind === USER_TYPES.barber && user.barbers.length) {
    data.barbers = user.barbers.map((barber) => ({
      id: barber.id,
      name: fullName(barber),
      email: barber.email,
    }));
  }

  if (user.kind === USER_TYPES.regularAdmin || user.kind === USER_TYPES.agent) {
    data.adminPermissions = user.permissions;
  }

  data.setAccountOwner = user.isAccountOwner;
  data.firstName = user.firstName;
  data.lastName = user.lastName;
  data.phone = user.phone;
  data.email = user.email;
  data.username = user.username;
  data.kind = user.kind.toString();
  data.enabled = user.enabled;
  data.optIn2FA = user.optIn2FA;
  data.brand = {
    id: user.brandId || null,
    name: user.brand ? user.brand.name : null,
  };

  if (user.brandId) {
    data.kind = USER_TYPES.brand.toString();
  }

  return data;
};

export const getInitialValues = (overrides = {}) => ({
  kind: '2',
  permissions: defPermissions,
  trackEmployeeTime: false,
  permissionPasscodeRequired: false,
  enabled: true,
  firstName: '',
  lastName: '',
  setAccountOwner: false,
  brand: {
    id: null,
  },
  adminPermissions: [],
  ...overrides,
});

const fields = ['username', 'kind', 'password', 'enabled', 'optIn2FA'];

export const beforeSave = (data, isEdit, initialValues) => {
  const model = pick(data, fields);
  model.kind = parseInt(model.kind, 10);
  model.brand = { id: null };

  const isAccountAlreadyOwner = isEdit && initialValues.setAccountOwner;

  // EDIT: Can't change status if the user is already the account owner.
  // ADD: Prompt for confirmation, whether there is already an account owner.
  if (!isAccountAlreadyOwner && data.setAccountOwner) {
    model.setAccountOwner = 'ask';
  }

  if (data.setAccountOwner) {
    model.firstName = data.firstName;
    model.lastName = data.lastName;
  }

  const isBrandType = model.kind === USER_TYPES.brand;

  if (isBrandType) {
    model.kind = USER_TYPES.shop;
  }

  if (model.kind === USER_TYPES.shop) {
    if (data.shopIds) {
      model.shopIds = data.shopIds.map((shop) => ({
        id: shop,
        permissions: data.permissions,
        trackEmployeeTime: data.trackEmployeeTime,
        permissionPasscodeRequired: data.permissionPasscodeRequired,
      }));
    }
    if (data.brand && isBrandType) {
      model.brand = {
        id: data.brand.id,
        permissions: data.permissions,
        trackEmployeeTime: data.trackEmployeeTime,
      };
    }
  }

  if (model.kind === USER_TYPES.barber) {
    model.barberId = data.barbers.map((barber) => barber.id);
  }

  if (model.kind === USER_TYPES.regularAdmin || model.kind === USER_TYPES.agent) {
    model.permissions = data.adminPermissions;
  }

  if (model.optIn2FA === null || model.optIn2FA === undefined) {
    delete model.optIn2FA;
  }

  return model;
};
